import { render, staticRenderFns } from "./Cure.vue?vue&type=template&id=e7ac47c8&scoped=true&"
import script from "./Cure.vue?vue&type=script&lang=js&"
export * from "./Cure.vue?vue&type=script&lang=js&"
import style0 from "./Cure.vue?vue&type=style&index=0&id=e7ac47c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ac47c8",
  null
  
)

export default component.exports